'use client'

import { useState } from "react"
import useEventListener from "@/components/plugins/EventListener"
import { formatCurrency } from "@/utils/Formatters"
import { strings } from '@/utils/I18n';

export default function VehiclePayment(props) {
  
  const [payment,setPayment] = useState(formatCurrency(props.payment))
  const [dealType, setDealType] = useState()
  
  useEventListener("vdp_payment_update", event => {
    if (event.detail) {
      setPayment(formatCurrency(event.detail.payment))
      setDealType(event.detail.dealType)
    }
    
  })

  if (!payment || payment == 0) return <></>
  
  return <>
          <span className='text-primary'>
            {payment + " "}
          </span>
          { 
            dealType != 'cash' && (!props.discount || props.discount <= 0) &&
            <span className='text-sm' dangerouslySetInnerHTML={{__html: strings(props.site)['vdp_estimateOnPrice'] }}></span>
          }
          { 
            dealType == 'cash' &&
            <span className='flex-column'>
              <span className='text-sm'>{ strings(props.site)['vdp_salePrice'] }</span>
            </span>
          }
        </>
  
}